import { useBlocker } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const useNavigationBlocker = (when: boolean) => {
  const { t } = useTranslation("common");

  useBlocker({
    shouldBlockFn: () => {
      if (!when) return false;

      const confirmLeave = window.confirm(t("prompts.areYouSureWantToLeave"));

      return !confirmLeave;
    }
  });

  return null;
};
